const canFormat =
  typeof Intl !== 'undefined' &&
  typeof Intl.RelativeTimeFormat === 'function' &&
  typeof Intl.DateTimeFormat === 'function'

const DIVISIONS = [
  { amount: 60, name: 'seconds' },
  { amount: 60, name: 'minutes' },
  { amount: 24, name: 'hours' },
  { amount: 7, name: 'days' },
  { amount: 4.34524, name: 'weeks' },
  { amount: 12, name: 'months' },
  { amount: Number.POSITIVE_INFINITY, name: 'years' },
]

function formatTimeAgo(date, locale) {
  let duration = (date - new Date()) / 1000

  for (const division of DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      const formatter = new Intl.RelativeTimeFormat(locale, {
        numeric: 'auto',
      })
      return formatter.format(Math.round(duration), division.name)
    }
    duration /= division.amount
  }
  return null
}

function localizedPostTime(post, locale) {
  if (!canFormat || !post.publishedAt) {
    return null
  }

  const dt = new Date(post.publishedAt)
  const timeString = formatTimeAgo(dt, locale.validLocale)

  return timeString[0].toUpperCase() + timeString.slice(1)
}

function postTime(publishedAt, locale) {
  if (!canFormat || !publishedAt) {
    return null
  }

  const options = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }

  const dt = new Date(publishedAt)

  return Intl.DateTimeFormat(locale.validLocale, options).format(dt)
}

export default localizedPostTime

export { postTime }
